// Mise a jour des apps Android installees en APK hors store : l'app embarque
// son numero de build a la compilation (__ANDROID_RELEASE__, injecte par
// vite.config.js depuis android-release.json) et le compare au bloc `android`
// de version.json publie sur le site.
// Depuis la mise en ligne sur Google Play (2026-10-09), `apkUrl` pointe vers la fiche
// Play : les apps installees depuis le site y sont envoyees (meme cle de signature).

const EMBEDDED = typeof __ANDROID_RELEASE__ !== 'undefined' ? __ANDROID_RELEASE__ : null;

export const VERSION_URL = 'https://www.clocook.fr/version.json';

export function getEmbeddedBuild() {
  return EMBEDDED?.build ?? 0;
}

export function compareBuilds(embeddedBuild, published) {
  if (!published || typeof published.build !== 'number') {
    return { available: false, required: false, apkUrl: null };
  }
  return {
    available: published.build > embeddedBuild,
    required: typeof published.minBuild === 'number' && embeddedBuild < published.minBuild,
    apkUrl: published.apkUrl || null
  };
}

/** Silencieux en cas d'echec reseau : l'app demarre normalement. */
export async function checkForUpdate() {
  try {
    const res = await fetch(`${VERSION_URL}?t=${Date.now()}`, { cache: 'no-store' });
    if (!res.ok) return { available: false, required: false, apkUrl: null };
    const data = await res.json();
    return compareBuilds(getEmbeddedBuild(), data.android);
  } catch {
    return { available: false, required: false, apkUrl: null };
  }
}
